import apis from "../../core/apis.js";

class TicketResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.ticket).get(options);
  }

  get(id) {
    return this.$resource(apis.ticket + id).get();
  }

  search(search = "") {
    return this.$resource(apis.ticket).get({ search });
  }

  post(item) {
    return this.$resource(apis.ticket).save(item);
  }

  resolve(id) {
    return this.$resource(apis.ticket + id + "/resolve").save();
  }

  update(id, item) {
    return this.$resource(apis.ticket + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }
}

export default TicketResource;



// WEBPACK FOOTER //
// ./src/resources/ticket/ticket.resource.js